module.exports = __webpack_public_path__ + "static/img/szpt48.8e30a26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/szpt48.jpg
// module id = RBvs
// module chunks = 73